import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from "@angular/common/http";
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BancoEnt } from '../models/Payku/Banco';
import { CreateClientForm } from '../models/Payku/CreateClientForm';
import { CuentaBancariaClienteEnt } from '../models/Payku/CuentaBancariaCliente';
import { StandardResponse } from '../models/StandardResponseAPI';
import { Response } from '../shared/models/Response';
import { AbonosPanelEnt } from '../models/Payku/AbonosPanelEnt';
import { PaykuTransactionEnt } from '../models/Payku/PaykuTransactionEnt';
import { PaykuAdicionalResponse } from '../models/Payku/PaykuAdicionalResponse';
@Injectable({
  providedIn: 'root'
})
export class PaykuService {
  private REST_API_SERVER = environment.backend_server + "/Payku";

  constructor(private http: HttpClient) { }
  getBancos(): Observable<BancoEnt[]> {
		return this.http.get<BancoEnt[]>(this.REST_API_SERVER + "/getBancos");
	}

  createClient(clientForm: CreateClientForm): Observable<Response<any>> {
    return this.http.post<Response<any>>(this.REST_API_SERVER + "/CreatePaykuAccount", clientForm);
  }

  getDatosBancarios(usuarioId: string): Observable<Response<CuentaBancariaClienteEnt[]>> {
    return this.http.get<Response<CuentaBancariaClienteEnt[]>>(this.REST_API_SERVER + `/GetDatosBancarios/${usuarioId}`);
  }

  desactivarNoticia(usuarioId: number | string): Observable<Response<boolean>> {
    return this.http.get<Response<boolean>>(this.REST_API_SERVER + `/DesactivarNoticia/${usuarioId}`);
  }

  getNoticia(usuarioId: number | string): Observable<Response<boolean>> {
    return this.http.get<Response<boolean>>(this.REST_API_SERVER + `/getNoticia/${usuarioId}`);
  }
  hasActiveAccount(emisorId: string): Observable<Response<boolean>> {
    return this.http.get<Response<boolean>>(this.REST_API_SERVER + `/HasActiveAccount/${emisorId}`);
  }
  obtenerConfig(emisorId: string) {
    return this.http.get<{
      termsAccepted: boolean;
      paykuHabilitado: PaykuAdicionalResponse;
      correoNotificacion: string | null;
      tiposDteActivos: number[];
    }>(`${this.REST_API_SERVER}/config/${emisorId}`);
  }

  activaDesactivarPayku(emisorId: string, habilitar: boolean) {
    return this.http.post<Response<string>>(`${this.REST_API_SERVER}/activaDesactivarPayku`, { emisorId, habilitar });
  }
  actualizarCorreoNotificacion(emisorId: string, correo: string) {
    return this.http.post<Response<string>>(`${this.REST_API_SERVER}/correo-notificacion`, { emisorId, correo });
  }
  actualizarTiposDte(emisorId: string, tipos: number[]) {
    return this.http.post<Response<string>>(`${this.REST_API_SERVER}/tipos-dte`, { emisorId, tipos });
  }
  getTiposCuenta() {
    return this.http.get<{ tipoCuentaId: number; nombre: string; descripcion: string }[]>(
      this.REST_API_SERVER + "/tipos-cuenta"
    );
  }

  getCuentaBancaria(emisorId: string) {
    return this.http.get<Response<{
      cuentaBancariaId?: string;
      sbif: string;
      tipoCuentaId: number;
      ultimos4Numero: string;
      rut: string;
      activa: boolean;
    }>>(this.REST_API_SERVER + `/cuenta-bancaria/${emisorId}`);
  }

  upsertCuentaBancaria(payload: {
    emisorId: string;
    sbif: string;
    tipoCuentaId: number;
    numCuenta: string;
    rut: string;
  }) {
    return this.http.post<Response<any>>(this.REST_API_SERVER + "/cuenta-bancaria", payload);
  }

  obtenerTiposDteHabilitados(emisorId: string): Observable<Response<number[]>> {
    return this.http.get<Response<number[]>>(`${this.REST_API_SERVER}/tipos-dte-habilitados/${emisorId}`);
  }

  validarAdicionalPaykuPorEmisor(emisorId: string): Observable<Response<PaykuAdicionalResponse>> {
    return this.http.get<Response<PaykuAdicionalResponse>>(`${this.REST_API_SERVER}/adicional-payku/${emisorId}`);
  }


  getAbonosByDate(emisorId: string, date: string): Observable<Response<AbonosPanelEnt>> {
    const url = `${this.REST_API_SERVER}/abonos/by-date/${emisorId}?date=${encodeURIComponent(date)}`;
    return this.http.get<Response<AbonosPanelEnt>>(url);
  }
  getTransactionsByDate(emisorId: string, date: string, pageNumber: number = 0, pageSize: number = 10, monthly: boolean = false): Observable<any> {
    const url = `${this.REST_API_SERVER}/abonos/transactions/${emisorId}?date=${encodeURIComponent(date)}&pageNumber=${pageNumber}&pageSize=${pageSize}&monthly=${monthly}`;
    return this.http.get<any>(url);
  }

  exportTransactionsMassive(emisorId: string, fechaDesde: string, fechaHasta: string): Observable<PaykuTransactionEnt[]> {
    const url = `${this.REST_API_SERVER}/abonos/export-massive/${emisorId}?fechaDesde=${encodeURIComponent(fechaDesde)}&fechaHasta=${encodeURIComponent(fechaHasta)}`;
    return this.http.get<PaykuTransactionEnt[]>(url);
  }
  estaLiquidado(dteId: string): Observable<Response<boolean>> {
    return this.http.get<Response<boolean>>(`${this.REST_API_SERVER}/transaccion-payku/liquidado/${dteId}`);
  }
  getTermsConditionsPdf(): Observable<HttpResponse<Blob>> {
    const url = `${this.REST_API_SERVER}/terms-conditions/pdf`;
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  }
   validarPaykuConPeriodoSemana(emisorId: string): Observable<boolean> {
    return this.validarAdicionalPaykuPorEmisor(emisorId).pipe(
      map(response => {
        const habilitado = response.data?.habilitado || false;
        const fechaContratacion = response.data?.fechaContratacion;
        
        if (!habilitado || !fechaContratacion) {
          return false;
        }

         return this.estaEnPeriodoSemanal(fechaContratacion);
      })
    );
  }
  estaEnPeriodoSemanal(fechaContratacion: string | Date | null | undefined): boolean {
    if (!fechaContratacion) {
      return false;
    }
    
    const fechaContrato = new Date(fechaContratacion);
    const fechaActual = new Date();

    fechaContrato.setHours(0, 0, 0, 0);
    fechaActual.setHours(0, 0, 0, 0);
    
    const diferenciaMilisegundos = fechaActual.getTime() - fechaContrato.getTime();
    const diasTranscurridos = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
    
    return diasTranscurridos >= 0 && diasTranscurridos <= 7;
  }
}
